import React, { useEffect, useState } from "react"
import styled from "styled-components"
import fonts from "../../../styles/fonts"
import colors from "../../../styles/colors"
import { withTranslation } from "gatsby-plugin-react-i18next"
import Field from "./Field"
import { Fields, Intro, SubmitButton, Title } from "./Styles"
import { sendForgetPasswordEmail } from "../../../services/user/user"
import { LOGIN_FORM } from "../../../context/form/formTypes"

const StyledForm = styled.form`
  margin-top: -2px;
  margin-bottom: -3px;
`

const StyledTitle = styled(Title)`
  margin-bottom: 38px;
  text-align: center;
`
const StyledIntro = styled(Intro)`
  margin: ${props => props.bottom ? "0 auto 40px" : "0 auto"};
  text-align: center;
  max-width: 405px;
`

const Message = styled(StyledIntro)`
  color: ${(props) => (props.error ? "#DB3232" : colors.green)};
  margin-top: -30px;
  margin-bottom: 40px;
`

const StyledSubmitButton = styled(SubmitButton)`
  margin: 40px 0 8px;
`

const PasswordLink = styled.div`
  ${fonts.helveticaNeue};
  color: ${colors.grey};
  font-size: 8px;
  line-height: 1.25;
  text-align: center;
  margin-bottom: 4px;
  button {
    cursor: pointer;
    background: transparent;
    ${fonts.helveticaNeue};
    color: ${colors.grey};
    font-size: 8px;
    line-height: 1.25;
    text-align: right;
    padding: 0;
    border: none;
    text-decoration: underline;
  }
`

const ForgottenPassword = ({ t, setContent }) => {
  const [formData, setFormData] = useState({
    email: "",
  })
  const [errors, setErrors] = useState({
    email: "",
  })
  const [submitError, setSumbitError] = useState(false)
  const [message, setMessage] = useState(null)
  const [sent, setSent] = useState(false)

  useEffect(() => {
    return () => {
      setSent(false)
    }
  }, [])

  const handleChange = (name, value) => {
    let updatedFormData = formData

    updatedFormData[name] = value
    setFormData(updatedFormData)
  }

  const validateForm = () => {
    let hasError = false
    const formFields = Object.keys(formData)
    const updatedErrors = {
      email: "",
      password: ""
    }

    formFields.forEach((formField) => {
      if (formData[formField].length === 0) {
        updatedErrors[formField] = t("account.form_empty_field_error")
        hasError = true;
      }
    })

    setErrors(updatedErrors)

    return hasError
  }

  const submitForm = async (e) => {
    e.preventDefault()

    if(!sent) {
      setMessage(null)
      setSumbitError(false)

      const hasError = validateForm()
      if (hasError) {
        return
      }
      try {
        await sendForgetPasswordEmail(formData.email)
        setSent(true)
        setMessage(t("account.forgot_password_message"))
      } catch (error) {
        console.error(error)
        setMessage(t("account.form_submit_error"))
        setSumbitError(true)
        setSent(false)
      }
    }
  }

  const switchToLogin = (e) => {
    e.preventDefault()
    setContent(LOGIN_FORM)
  }

  return (
    <StyledForm onSubmit={submitForm}>
      <StyledTitle>{t("account.forgot_password_title")}</StyledTitle>
      <StyledIntro>{t("account.forgot_password_intro1")}</StyledIntro>
      <StyledIntro bottom >{t("account.forgot_password_intro2")}</StyledIntro>
      {message && <Message error={submitError}>{message}</Message>}
      <Fields>
        <Field
          data={formData}
          name="email"
          placeholder={t("account.form_email_placeholder")}
          label={t("account.form_email_placeholder")}
          handleChange={handleChange}
          type="email"
          error={errors.email}
          isPopup
        />
      </Fields>
      <StyledSubmitButton type="submit">
        {t("account.forgot_password_submit")}
      </StyledSubmitButton>
      <PasswordLink  i18nKey={"remember_password_link"}>
        You remember your password? No problem, <button type="button" onClick={switchToLogin}>sign up here as usual</button>
      </PasswordLink>
    </StyledForm>
  )
}

export default withTranslation()(ForgottenPassword)
